<template>
  <div class="home">
    <div class="filter-wrapper filter-wrapper-tab">
      <CallsLink />
      <div class="link-filter-wrapper auto-call-report__filter-wrapper">
        <div>
          <div class="date-range-picker">
            <DatePicker
              ref="dateRangePicker"
              v-model="dateRange"
              range
              type="daterange"
              format="DD MMM YYYY"
              placeholder="Start Date - End Date"
              popper-class="green-theme"
              range-separator=" — "
              :lang="{
                formatLocale: {
                  firstDayOfWeek: 1,
                }
              }"
              input-class="custom-input"
              :confirm="true"
              confirm-text="OK"
              @change="changeDateRange"
              @clear="resetToDefault">
              <template #icon-calendar>
                <font-awesome-icon :icon="dataCalendarDays" />
              </template>
            </DatePicker>
          </div>

          <v-select
            v-model="dataSelectTeamsValue"
            :options="dataSelectOptionsTeam"
            label="name"
            :components="{ Deselect: dataComponentDeselect }"
            placeholder="All Teams"
            :class="[
              'call-select call-select-filter teams-filter',
              dataSelectTeamsValue ? 'call-select--value' : null,
            ]"
            @input="onSelectTeams">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <font-awesome-icon :icon="dataIconDown" />
              </span>
            </template>
            <template slot="no-options">
              Name Team
            </template>
            <template
              slot="option"
              slot-scope="option">
              <div class="d-center">
                <font-awesome-icon
                  v-if="!option.is_active"
                  class="tabel-icon--red"
                  style="font-size: 10px"
                  :icon="dataIconLock" />
                {{ option.name }}
              </div>
            </template>
          </v-select>

          <CallCheckedClosedOpenedCustom
            v-model="dataFilterTypeAutoCall"
            class="auto-call-report__switch"
            :config-tab="configTab" />

          <span
            style="display: flex; align-items: center;"
            class="last-update-wrapper">Upd: {{ computedLastUpdate | dateFilterUTC }}</span>
        </div>
        <div />
      </div>
    </div>
    <div class="home-mian-wr">
      <div
        class="table-wrapper table-wrapper-autocallreport"
        style="width: 50%;">
        <EmptyTable
          v-if="isLoaded && !computedDataAutoCallRows.length" />
        <table
          v-else-if="isLoaded"
          class="table table-hover deposits-table">
          <thead>
            <tr>
              <th
                v-for="field in dataMixinAutoCallReportFields"
                :key="field.key"
                :class="field.thClass"
                :style="field.thStyle">
                {{ field.label }}
                <span
                  v-if="field.subLabel"
                  class="">{{ field.subLabel }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="team in computedDataAutoCallRows">
              <tr
                v-for="row in team.rows"
                :key="`${team.team_id}_${row.run_type}`"
                :class="[
                  'row-white',
                  team.team_id === dataHoverTeamId
                    ? 'auto-call-report-row-hover'
                    : null,
                ]"
                @mouseenter="dataHoverTeamId = team.team_id"
                @mouseleave="dataHoverTeamId = null">
                <td
                  v-if="(team.rows.length === 2 && row.run_type === 'auto') || team.rows.length === 1"
                  class="call-td call-td--bold"
                  :rowspan="team.rows.length">
                  {{ team.team_name }}
                </td>
                <td
                  class="call-td call-tabel--center"
                  style="text-transform: capitalize;">
                  {{ row.run_type }}
                </td>
                <td class="call-td call-tabel--center">
                  {{ row.bonuses_count }}/{{ row.bonuses_manual_count }}
                </td>
                <td class="call-td call-tabel--right">
                  {{ row.tasks_count }}
                </td>
                <td class="call-td call-tabel--right">
                  {{ row.tasks_success_count }}
                </td>
                <td class="call-td call-tabel--right">
                  {{ row.tasks_cancelled_count }}
                </td>

                <td
                  v-if="(team.rows.length === 2 && row.run_type === 'auto') || team.rows.length === 1"
                  class="call-tabel-action"
                  :rowspan="team.rows.length">
                  <call-table-deposits-actions

                    :rotate="team._showDetails"
                    @on-action="onActions(team)" />
                </td>
              </tr>
              <tr
                v-if="team._showDetails"
                :key="`details_${team.team_id}`"
                class="row-details">
                <td
                  style="padding: 0; border: none;"
                  :colspan="dataMixinAutoCallReportFields.length">
                  <table
                    v-if="team.projects.length"
                    class="table table-hover deposits-subtable">
                    <thead>
                      <tr>
                        <th
                          v-for="field in dataMixinAutoCallReportSubFields"
                          :key="field.key"
                          :class="field.thClass"
                          :style="field.thStyle">
                          {{ field.label }}
                          <span
                            v-if="field.subLabel"
                            class="">{{ field.subLabel }}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="project in team.projects">
                        <tr
                          v-for="row in project.rows"
                          :key="`${project.project_id}_${row.run_type}`"
                          :class="[
                            'row-blue',
                            project.project_id === dataHoverProjectId
                              ? 'auto-call-report-row-hover'
                              : null,
                          ]"
                          @mouseenter="dataHoverProjectId = project.project_id"
                          @mouseleave="dataHoverProjectId = null">
                          <!-- (team.rows.length === 2 && row.run_type === 'auto') || team.rows.length === 1 -->
                          <!-- v-if="row.run_type === 'auto'" -->
                          <td
                            v-if="(project.rows.length === 2 && row.run_type === 'auto') || project.rows.length === 1"
                            class="call-td call-td--bold"
                            :rowspan="project.rows.length">
                            {{ project.project_name }}
                          </td>
                          <td
                            class="call-td call-tabel--center"
                            style="text-transform: capitalize;">
                            {{ row.run_type }}
                          </td>
                          <td class="call-td call-tabel--center">
                            {{ row.bonuses_count }}/{{ row.bonuses_manual_count }}
                          </td>
                          <td class="call-td call-tabel--right">
                            {{ row.tasks_count }}
                          </td>
                          <td class="call-td call-tabel--right">
                            {{ row.tasks_success_count }}
                          </td>
                          <td class="call-td call-tabel--right">
                            {{ row.tasks_cancelled_count }}
                          </td>
                          <td class="call-tabel-action" />
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div
        class="chart-right"
        style="width: 50%;">
        <AutoCallChart
          v-if="totalAmountByDate.length"
          :formatted-range="formattedRange"
          :total-amount-by-date="totalAmountByDate"
          :data-select-chart-value-id="dataSelectChartValueId"
          @dataSelectChartValue="
            (value) => {
              dataSelectChartValueId = value.id;
              $_ajax({ reset: true });
            }
          " />
      </div>
    </div>

    <CallUpdateProjectTimeSettings
      v-model="dataShowProjectSetting"
      :project-id="projectId"
      :project-data="projectData"
      @on-update="onSelectRefresh" />

    <CallModal
      v-model="isOpenModal"
      :data="dataModal"
      use-view="AutoCalls"
      @input="handlerModal" />
  </div>
</template>

<script>
import AutoCallChart from '@/views/desktop/calls/components/AutoCallChart.vue';
import CallTableDepositsActions from '@/components/desktop/CallTableDepositsActions';

import CallsLink from './components/CallsLink.vue';
import CallModal from '@/components/common/modals/CallModal.vue';
import {
  AUTOCALL_REPORT,
  TEAMS_GET_ALL,
  PROJECTS_GET_ALL,
  AUTOCALL_UPDATE_RUN_STATUS,
  AUTOCALL_RUN_ARCHIVE
} from '../../../store/types/actions.types';
import helper from '../../../service/helper';
import {
  faCheck,
  faClock,
  faFilter,
  faSearch,
  faTimes,
  faPowerOff
} from '@fortawesome/pro-regular-svg-icons';
import CallUpdateProjectTimeSettings from '@/components/common/modals/CallUpdateProjectTimeSettings';
import selectAllTeams from '../../../mixins/select/selectAllTeams';
import { mapGetters } from 'vuex';
import selectOperators from '../../../mixins/select/selectOperators';
import selectReportPeriod from '../../../mixins/select/selectReportPeriod';
import 'vant/lib/popover/style';
import autoCallProjectTable from '../../../mixins/table/autoCallProjectTable';
import CallCheckedClosedOpenedCustom from '@/components/common/CallCheckedClosedOpenedCustom';
import moment from 'moment';
import { faCalendarDays } from '@fortawesome/pro-light-svg-icons';

const defaultDate = [
  moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
  moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
];

export default {
  name: 'AutoCallsReport',
  components: {
    AutoCallChart,
    CallTableDepositsActions,
    CallsLink,
    CallUpdateProjectTimeSettings,
    CallModal,
    CallCheckedClosedOpenedCustom
  },
  mixins: [
    autoCallProjectTable,
    selectAllTeams,
    selectOperators,
    selectReportPeriod
  ],
  data () {
    const filter = {
      dataIconLock: faPowerOff,
      dataIconFilter: faFilter,
      dataIconClose: faTimes,
      dataIconSearch: faSearch,
      dataShowPopover: false,
      dataSelectOptionsTeam: [],
      dataSelectProject: null,
      dataProjectList: [],
      filterPhone: [
        {
          active: false,
          name: 'Successful',
          key: 'success'
        },
        {
          active: false,
          name: 'Cancelled',
          key: 'cancelled'
        },
        {
          active: false,
          name: 'No Answer',
          key: 'noanswer'
        },
        {
          active: false,
          name: 'Rejected',
          key: 'rejected'
        },
        {
          active: false,
          name: 'Invalid Number',
          key: 'invalid_number'
        },
        {
          active: false,
          name: 'Not Available',
          key: 'not_available'
        }
      ]
    };
    const issues = {
      dataSelectIssueValue: null,
      dataSelectOptionsIssues: []
    };

    return {
      totalAmountByDate: [],
      dataSelectChartValueId: 'day',
      dataCalendarDays: faCalendarDays,
      //
      startDate: null,
      endDate: null,
      //
      defaultDateRange: [new Date(defaultDate[0]), new Date(defaultDate[1])],
      dateRange: [new Date(defaultDate[0]), new Date(defaultDate[1])],
      formattedRange: [defaultDate[0], defaultDate[1]],

      dataFilterActiveArchived: 'active',
      dataModal: null,
      isOpenModal: false,
      isLoaded: false,
      dataFilterTypeAutoCall: null,
      dataFilterStatusAutoCall: null,
      dataShowProjectSetting: false,
      projectId: 1,
      projectData: {},
      statRefreshedAt: '',
      dataIconCheck: faCheck,
      dataIconError: faTimes,
      dataIconClock: faClock,
      dataObjPagination: {},
      dataObjPermissions: {},
      dataAutoCall: [],
      dataHoverTeamId: null,
      dataHoverProjectId: null,
      dataDesc: true,
      dataOrderBy: 'created_at',
      dataSearch: null,
      configTab: [
        {
          name: 'All',
          action: null
        },
        {
          name: 'Auto',
          action: 'auto'
        },
        {
          name: 'Custom',
          action: 'custom'
        }
      ],
      ...filter,
      ...issues
    };
  },

  computed: {
    ...mapGetters({
      computedIsOperator: 'auth/isOperator',
      computedIsModerator: 'auth/isModerator',
      computedCurrentUser: 'auth/currentUser',
      computedIsAdmin: 'auth/isAdmin'
    }),

    computedDataFilterIsActive () {
      if (this.dataFilterActiveArchived === 'active') {
        return false;
      }
      if (this.dataFilterActiveArchived === 'archive') {
        return true;
      }
      return undefined;
    },

    computedProjectList () {
      return this.dataProjectList
        .map(({ id, name, is_active }) => {
          return { id, name, is_active };
        })
        .sort((a, b) => b.is_active - a.is_active);
    },
    computedFilterCount () {
      const typeAutoCall = this.dataFilterTypeAutoCall ? 1 : 0;
      const statusAutoCall = this.dataFilterStatusAutoCall ? 1 : 0;

      return 0 + typeAutoCall + statusAutoCall;
    },

    computedDataAutoCallRows () {
      const res = this.dataAutoCall.map((team) => ({
        ...team,
        rows: this.getRunRows(team.totals),
        projects: (team.projects || []).map((project) => ({
          ...project,
          rows: this.getRunRows(project.stats)
        }))
      }));

      return res;
    },

    computedLastUpdate () {
      return this.statRefreshedAt;
    }
  },

  watch: {
    dataFilterTypeAutoCall (v) {
      this.$_ajax({ reset: true });
    }
  },

  async created () {
    this.$_ajax = ((options = {}) => {
      this.isLoaded = false;
      let _page = 0;
      let _limit = 50;

      const { currentRoute: { name: pageName } = {} } = this.$router;

      const _filterKey = `_filter${pageName}`;

      if (!helper.isEmpty(this.$route.query, _filterKey)) {
        try {
          options = helper.clearObject(
            JSON.parse(this.$route.query[_filterKey])
          );

          const _arrFilter = [
            'dateRange',
            'desc',
            'orderBy',
            'limit',
            'page',
            'period',
            'team_ids',
            'project_ids',
            'operator_ids',
            'limit',
            'page',
            'search',
            'statuses',
            'issue_id',
            'type',
            'status',
            'is_archived'
          ];

          for (const _key of _arrFilter) {
            if (!helper.isEmpty(options, _key)) {
              switch (_key) {
                case 'dateRange':
                  this.dateRange = options[_key].map((d) => new Date(d));
                  this.formattedRange = options[_key];
                  break;
                case 'type':
                  this.dataFilterTypeAutoCall = options[_key];
                  break;
                case 'status':
                  this.dataFilterStatusAutoCall = options[_key];
                  break;
                case 'period':
                  this.dataSelectLastDayValue = options[_key];
                  break;
                case 'search':
                  this.dataSearch = options[_key];
                  break;
                case 'desc':
                  this.dataDesc = options[_key];
                  break;
                case 'orderBy':
                  this.dataOrderBy = options[_key];
                  break;
                case 'team_ids':
                  this.dataSelectTeamsValue = options[_key];
                  break;
                case 'project_ids':
                  this.dataSelectProject = options[_key];
                  break;
                case 'issue_id':
                  this.dataSelectIssueValue = options[_key];
                  break;
                case 'operator_ids':
                  this.dataSelectOperatorValue = options[_key];
                  break;
                case 'limit':
                  _limit = options[_key];
                  break;
                case 'page':
                  _page = options[_key];
                  break;
                case 'statuses':
                  this.filterPhone = options[_key];
                  break;
                case 'is_archived':
                  this.dataFilterActiveArchived = options[_key];
                  break;
              }
            }
          }
        } catch (e) {
          console.log('Error query params');
        }
      }

      return async ({
        dateRange = this.formattedRange,
        desc = this.dataDesc,
        orderBy = this.dataOrderBy,
        teamId = this.dataSelectTeamsValue,
        projectId = this.dataSelectProject,
        issuesId = this.dataSelectIssueValue,
        limit = null,
        page = null,
        reset = false,
        search = this.dataSearch,
        is_archived = this.dataFilterActiveArchived
      } = options) => {
        this.$store.dispatch('loading/startLoading');

        try {
          if (!this.dataSelectLastDayValue) {
            this.dataSelectLastDayValue = {
              ...this.dataSelectLastDayValueDefault
            };
          }

          if (!helper.isEmpty(page) && page !== _page) {
            _page = page;
          }

          if (!helper.isEmpty(limit) && limit !== _limit) {
            _limit = limit;
          }

          if (reset) {
            _page = 0;
          }

          const { payload = {}, misc: { paging = {}, permissions = {}, stats_refreshed_at = '' } = {} } =
            await this.$store.dispatch(
              `autocall/${AUTOCALL_REPORT}`,
              helper.clearObject({
                params: {
                  start_timestamp: dateRange[0],
                  end_timestamp: dateRange[1],
                  timezone: 0,
                  run_type: [this.dataFilterTypeAutoCall],
                  team_ids: helper.clearObject([teamId?.id]),
                  period_group_by: this.dataSelectChartValueId
                }
              })
            );

          this.statRefreshedAt = stats_refreshed_at;
          this.dataObjPermissions = permissions;
          this.dataObjPagination = paging;
          this.dataAutoCall = payload.grouped_by_teams;
          this.totalAmountByDate = payload.grouped_by_period;

          this.$router
            .replace({
              ...this.$router.currentRoute,
              query: {
                [_filterKey]: JSON.stringify(
                  helper.clearObject({
                    dateRange,
                    desc,
                    search,
                    period: this.dataSelectLastDayValue,
                    orderBy,
                    team_ids: teamId,
                    project_ids: projectId,
                    issue_id: issuesId,
                    limit: _limit,
                    page: _page,
                    operator_ids: this.computedIsOperator
                      ? [this.computedCurrentUser]
                      : this.dataSelectOperatorValue,
                    statuses: this.filterPhone,
                    status: this.dataFilterStatusAutoCall,
                    type: this.dataFilterTypeAutoCall,
                    is_archived: this.dataFilterActiveArchived
                  })
                )
              }
            })
            .catch(() => {});

          options = {};
          this.isLoaded = true;
        } finally {
          this.$store.dispatch('loading/stopLoading');
        }
      };
    })();

    this.$store.dispatch('loading/startLoading');

    try {
      const [
        {
          payload: { list: listTeam = [] }
        }
      ] = await Promise.all([
        this.$store.dispatch(`team/${TEAMS_GET_ALL}`, {
          params: {
            short: true,
            has_auto_call: true
          }
        }),
        // this.$_ajaxUserAll(),
        this.$_ajax(),
        this.getProjects()
        // this.$_ajaxIssues()
      ]);

      this.dataSelectOptionsTeam = listTeam.sort(
        (a, b) => b.is_active - a.is_active
      );
    } finally {
      this.$store.dispatch('loading/stopLoading');
    }
  },

  methods: {
    changeDateRange () {
      if (this.$refs.dateRangePicker) {
        this.$refs.dateRangePicker.closePopup();
      }
      setTimeout(() => {
        if (this.dateRange.length === 2) {
          this.formattedRange = [
            moment(this.dateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
            moment(this.dateRange[1])
              .endOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
          ];
          this.$_ajax();
        }
      }, 10);
    },

    resetToDefault () {
      this.dateRange = [...this.defaultDateRange];
    },

    handlerModal (action) {
      if (action === 'cancel') {
        this.isOpenModal = false;
        this.dataModal = null;
      }
      if (action === 'confirm') {
        const { id, action: actionApi } = this.dataModal;
        this.updateAutoCallStatus(id, actionApi);
        this.isOpenModal = false;
        this.dataModal = null;
      }
      if (action === 'archive') {
        const { id } = this.dataModal;
        this.archiveAutoCallRun(id);
        this.isOpenModal = false;
        this.dataModal = null;
      }
    },

    onSearchClear (e, flag) {
      const { currentRoute: { name: pageName } = {} } = this.$router;
      const _filterKey = `_filter${pageName}`;

      const { search = '' } = JSON.parse(this.$route.query[_filterKey]);
      if (flag === 'dataSearch' && search && !this.dataSearch) {
        this.$_ajax({ reset: true });
      }
    },

    onActions (team) {
      const original = this.dataAutoCall.find(
        (item) => item.team_id === team.team_id
      );
      if (original) {
        this.$set(original, '_showDetails', !original._showDetails);
      }
    },

    async archiveAutoCallRun (id) {
      try {
        await this.$store.dispatch(`autocall/${AUTOCALL_RUN_ARCHIVE}`, {
          id,
          params: helper.clearObject({})
        });
        this.$_ajax({ reset: true });
      } catch (error) {
        console.log(error);
      }
    },

    async updateAutoCallStatus (id, action) {
      try {
        await this.$store.dispatch(`autocall/${AUTOCALL_UPDATE_RUN_STATUS}`, {
          id,
          params: helper.clearObject({
            action
          })
        });
        this.$_ajax({ reset: true });
      } catch (error) {
        console.log(error);
      }
    },

    async getProjects () {
      try {
        const {
          payload: { list = [] }
          // misc: { paging = {} }
        } = await this.$store.dispatch(`project/${PROJECTS_GET_ALL}`, {
          params: helper.clearObject({})
        });

        this.dataProjectList = list
          .map((item) => {
            item.actions = false;
            return item;
          })
          .filter((item) => item.auto_calls_available);
      } catch (error) {
        console.log(error);
      }
    },

    onSearch () {
      this.$_ajax({ reset: true });
    },

    clickFilterSend () {
      this.dataShowPopover = false;
      this.$_ajax({ reset: false });
    },
    clickFilterCancel () {
      this.dataFilterTypeAutoCall = null;
      this.dataFilterStatusAutoCall = null;
      this.dataShowPopover = false;
      this.$_ajax({ reset: true });
    },
    onSelectRefresh () {
      this.$_ajax({ reset: true });
    },
    onSelectTeams () {
      this.dataSelectOperatorValue = null;
      this.dataSelectIssueValue = null;
      // this.$_ajaxIssues(this.dataSelectTeamsValue?.id);
      this.$_ajax({ reset: true });
    },
    methodTypeCall (value = '') {
      const [hour = 0, minutes = 0, seconds = 0] = value?.split(':') ?? [];
      const allDuration = +seconds + minutes * 1 * 60 + 1 * hour * 3600;

      if (allDuration === 0) {
        return 'danger';
      } else if (allDuration > 1 && allDuration < 20) {
        return 'warning';
      }
      return 'success';
    },
    onSortTabel ({ sortBy, sortDesc }) {
      this.dataDesc = sortDesc;
      this.dataOrderBy = sortBy;
      this.$_ajax();
    }
  }
};
</script>

<style lang="scss">
.home-mian-wr {

  .chart-right {
    position: relative;
    .chart-card {
      top: 16px;
      left: 0;
      position: sticky;
    }
  }
}
.auto-call-report__switch {
  label {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}
.auto-call-report__filter-wrapper {
  .mx-input-wrapper {
    .custom-input {
      width: 100%;
    }
  }
  .date-range-picker {
    max-width: 220px;
    display: flex;
    align-items: center;
    background: #eeeeef;
    padding-left: 8px;
    border-radius: 8px;
    margin-right: 8px;
  }

  .custom-input {
    border: none;
    background: transparent;
    font-size: 14px;
    width: 100%;
  }
}

.table-status-running {
  color: #e96c2c;
  text-transform: capitalize;
}
.table-status-complete {
  color: #20a052;
  text-transform: capitalize;
}
.table-status-stopped {
  color: #dd2f43;
  text-transform: capitalize;
}
.table-type-auto {
  text-transform: capitalize;
}
.table-type-custom,
.table-status-paused {
  color: #e96c2c;
  text-transform: capitalize;
}

.call-td--no-wrap {
  white-space: nowrap;
}

.table-wrapper-autocallreport {
  height: min-content;
  .auto-call-report-row-hover {
    background-color: rgba(32, 160, 82, 0.1) !important;
  }
  .call-tabel-action {
    width: 50px;
  }
  .table_actions {
    text-align: center;
  }
  .deposits-subtable {
    .call-th {
      padding: 0 !important;
    }
  }
}

.link-filter-wrapper__search {
  width: 220px;
}
</style>

<style lang="scss" scoped>
.date-range-picker {
  max-width: 220px;
  display: flex;
  align-items: center;
  background: #eeeeef;
  padding-left: 8px;
  border-radius: 8px;
  margin-right: 8px;
}

.home-mian-wr {
  display: flex;
  gap: 32px;
  > * {
    flex: 1;
  }
}
</style>
